
import { LuSmartphoneNfc } from "react-icons/lu";
import { InterpretationCard } from "../../components/forms/interpretation.components";
import Navbar1 from "../../components/mynavbar/navbar1.components";
import './homepage.styles.scss'
import { Bs0Circle, BsChatSquareText, BsChatSquareTextFill } from "react-icons/bs";
import { RiCustomerService2Line } from "react-icons/ri";
import { Accordion1 } from "../../components/others/accordion1.components";
import { Accordion2 } from "../../components/others/accordion2.components";
import SFBanner from "../../components/others/services-footer-banner.components";
import { TranslationCard } from "../../components/forms/translation.components";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@material-tailwind/react";


// const Services = () => {

//     const serviceId = useParams();

//     useEffect(() => {
//         console.log(`Service ID: ${serviceId}`);
//     }, [serviceId]); // Logs whenever `serviceId` changes

//     return(
//         <>
//         <div className="header">
//             <Navbar1 />
//         </div>

//         { serviceId === 1 ? (
//         <div className="general-container services-div py-32 flex">
//             <div className="services-left w-1/3">
//                 <InterpretationCard />
//             </div>

//             <div className="services-right w-2/3">
//                 <Accordion1 />
//             </div>
//         </div>
//         ) : (
//         <div className="general-container services-div py-32 flex">
//             <div className="services-left w-1/3">
//                 <TranslationCard />
//             </div>

//             <div className="services-right w-2/3">
//                 <Accordion2 />
//             </div>
//         </div>
//         )}
//         <SFBanner />

//         </>
//     );
// }

// export default Services;





const Services = () => {
  const { serviceId } = useParams();

  useEffect(() => {
    console.log(`Service ID: ${serviceId}`);
  }, [serviceId]); // Logs whenever `serviceId` changes

  return (
    <>
      <div className="header">
        <Navbar1 />
      </div>

      {serviceId === "interpretation" ? (
        <div className="general-container services-div py-32 sm:flex">
          <div className="services-left w-full sm:w-1/3">
            <InterpretationCard />
          </div>
          <div className="services-right w-full sm:w-2/3 p-2">
            <Accordion1 />
            <a href="/services/translation"><Button className="mt-4 float-end bg-gradient-to-r from-cyan-500 to-blue-500">Get A Translation Quote</Button></a>
          </div>
        </div>
      ) : (
        <div className="general-container services-div py-32 sm:flex">
          <div className="services-left w-full sm:w-1/3">
            <TranslationCard />
          </div>
          <div className="services-right w-full sm:w-2/3 p-2">
            <Accordion2 />
            <a href="/services/interpretation"><Button color="black" className="mt-4 float-end">Request Interpreting</Button></a>
          </div>
        </div>
      )}

      <SFBanner />
    </>
  );
};

export default Services;